import { Modals, Consts } from '../dependencies';

import AddSupplier from '../components/AddSupplier';

const { withModal } = Modals.HOC;

const modalId = Consts.modals.CREATE_SUPPLIER;

export default withModal(modalId)(AddSupplier);
